var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8332 22.4784C15.1239 23.1241 18.6739 24.064 20.8041 23.8879C22.9344 23.7118 26.3547 20.8935 27.0003 19.9543C27.646 19.0151 26.1615 18.8977 24.6769 19.6608C23.1924 20.4239 18.4165 21.9508 16.1573 19.6608C16.1573 19.6608 21.385 20.1304 21.5788 19.6608C21.7727 19.1912 20.998 18.4281 16.932 17.547C12.8661 16.6665 9.96106 17.547 9.96106 17.547V23.1835C9.96035 23.1828 12.5425 21.8327 13.8332 22.4784Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41168 17.5464H5.31354V23.5952H8.41168V17.5464Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3998 14.8256C15.6618 14.8256 16.7539 14.1287 17.3443 13.1076L25.5008 15.2112L25.8421 13.8891L24.8319 13.6284L25.4162 11.3759L24.0954 11.0333L23.5112 13.2878L22.3181 12.9799L22.8901 10.6906L21.5666 10.3596L20.9966 12.6393L17.7729 11.808C17.7886 11.677 17.8132 11.548 17.8132 11.4128C17.8132 9.53099 16.2822 8 14.4004 8C12.5186 8 10.9876 9.53095 10.9876 11.4128C10.9876 13.2946 12.5186 14.8256 14.3998 14.8256ZM14.3998 9.36513C15.5287 9.36513 16.4474 10.2838 16.4474 11.4128C16.4474 12.5418 15.5287 13.4605 14.3998 13.4605C13.2708 13.4605 12.3521 12.5418 12.3521 11.4128C12.3521 10.2838 13.2708 9.36513 14.3998 9.36513Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesSeven);
export default __webpack_public_path__ + "static/media/features-seven.456a7755.svg";
export { ForwardRef as ReactComponent };